

import { Component, Vue, Prop } from 'vue-property-decorator';
import IBPaymentCardButton from "@/components/IBPayment/IBPaymentCardButton.vue";
import { IAction } from "@/components/IBPayment/interface";

@Component({
	components: {
		IBPaymentCardButton
	}
})
export default class IBPaymentCardActions extends Vue {

	@Prop({ type: Array, default: () => [] })
	readonly list!: IAction[]

}

